import React, { useState, useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useAccountCheck, useBusinessAddr, useCartData, useLoading, useMbox, useScheduleDate, useServiceablitityData, useSessionData, useStepsData, useVasData, useVendor } from '../../hooks/order';
import { clearSessionOrderAccessToken, getAggregatedAddress, getBaseUrl, getFixedCostWith$, getValid$Cost, getWirelessServRef, isUndefinedNullOrEmpty, replaceServiceName, getUpdatedServRef, getSessionOrderAccessToken, getProductPrice, getPromoPrice, getPromoEndMonth, isWhiOrElfwPricing, calculateTotalMonthlyCharge } from '../../common/common';
import { useFFReferral } from '../../hooks/useFFReferralSession';
import { billingPeriod, cardErrorModalMessage, OrderStatus, routesConfig, referrerSourceMap } from '../../util/util';
import { useDispatch } from 'react-redux';
import { saveFirstStep, saveWirelessPlanInfo, saveInternetPlan, resetState, updateErrorMsg, updateCardErrorModal, updateCustTC, submitOrder, updateOrder, setMBoxReqObj, saveVasPlanInfo, setSelectedBundle, saveScheduleDateTime, setRtsVisible, setActiveProductTab } from '../../store/action/OrderAction';
import { useLocation, useNavigate } from 'react-router-dom';
import { getConfigs } from '../../config';
import { getOrderSubmissionModel } from '../../helpers/OrderHelperFunctions';
import CheckoutHeadText from '../Order/Checkout/CheckoutHeadText';
import { getPanelKeys } from '../Order/Checkout/CheckOut';
import MobileInfomration from '../common/MobileInfomration';
import moment from 'moment-timezone';
import { EECproductRemoveFromCart, EECtransactionSuccess } from '../../common/GTMScripts';
import { v4 as uuid } from 'uuid';
import useLeadsSDK from '../../hooks/useLeadsSDK';
import RtsModal from './RtsModal';
import { formatLocalDate } from '../Order/SinglePageCheckout/scheduleUtils';
import PropTypes from 'prop-types';
import BroadbandInfo from './BroadbandInfo';
import { CLEAR_BROADBAND_DATA } from '../../store/action/Types';

const config = getConfigs();

const CartInformation = (props) => {
  const { t } = useTranslation();
  const leads = useLeadsSDK();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orderInfo, sessionResponse, referrer } = useSessionData();
  const { loading, expressLoading } = useLoading();
  const { scheduleDateTime, rawScheduleDateTime } = useScheduleDate();
  const { normalizedAddress, serviceabilityCheck, scheduleAppt } = useServiceablitityData();
  const { bundleData } = serviceabilityCheck;
  const { isBusinessAddress } = useBusinessAddr();
  const { mboxRequired = [] } = useMbox();
  const { paymentInfo, chgQuestionInfo } = useStepsData();
  const { checkAccount } = useAccountCheck();
  const { isElnkMailboxReq } = useMbox();
  const showCreateAccTile = config.SHOW_PSWD_CQAS === 'true' ? true : isElnkMailboxReq;
  const { payment: paymentPanelKey } = getPanelKeys(showCreateAccTile);
  let { servRef, getBroadbandLabel, isBroadbandLabelError } = useCartData();
  const { isADSL, adslCost = 0, installationCost = 0, modemFee = 0, simCharge = 0, isInternetAdded, isMobileAdded, internetPlan, wirelessCartInfo, isProductsAdded, productCount, monthlyCharge = 0, isWhiAdded, isScheduleSuppressed, vasPlan, vasPlanInfo, isMobileContainer, total, serviceTerm, isBundleAdded, bundleDiscount, selectedBundleData, getOneTimeChargesHeadingValue, getOneTimeChargesLabel, getOneTimeChargesLabelValue, getMobilePriceLabel, mobileMrcCombinedVal, getMobilePriceValue, getMobilePrice, spanishLanguagePref, installType, isCsiEligible } = useCartData();
  const totalMonthlyCharge = calculateTotalMonthlyCharge(monthlyCharge, isBundleAdded, bundleDiscount);
  const { isVasOnlyFlow } = useVasData();
  const { password } = checkAccount;
  const { firstName, lastName, email, orderAccessToken, accountEmail, phoneNum, installPhone } = orderInfo;
  const billingAddress = isUndefinedNullOrEmpty(orderInfo.billingAddress) ? '' : orderInfo.billingAddress;
  const serviceAddress = isVasOnlyFlow && isUndefinedNullOrEmpty(normalizedAddress.address1)
    ? getAggregatedAddress(orderInfo.serviceAddress || orderInfo)
    : getAggregatedAddress(normalizedAddress);
  const shippingAddress = isUndefinedNullOrEmpty(orderInfo.shippingAddress) ? '' : orderInfo.shippingAddress;
  const { wirelessPlanInfo = [] } = wirelessCartInfo;
  const {
    agentReadTC,
    encryptedCcn,
    encryptedCvc,
    integrityCheck,
    expirationDate,
    paymentType,
    abaNum,
    bankAccountNum,
    bankAccountType,
  } = paymentInfo;
  const { question, answer } = chgQuestionInfo;
  const [showErrorModal, setShowErrorModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [tcAgree, setTcAgree] = useState(false);
  // Set only by CartSummary.js (single-page checkout) - swaps the cart body's markup to match
  // the SPC Figma design (no Edit links, a standalone Terms section). The default rendering
  // below is used by the multi-step checkout, the /products sidebar (FixedFooter) and the
  // mobile cart drawer (FixedCardFooter). Both layouts list One-Time Charges before Monthly
  // Charges - a deliberate, client-requested reorder that applies to every cart, not just
  // the SPC. Reuses every value/helper already computed in this component - no separate data
  // or pricing logic.
  const isSpc = Boolean(props.isSpc);
  const prodPage = window.location.href.includes('product');
  const autoSubmitRef = useRef(false);
  const sessionOrderAccessToken = getSessionOrderAccessToken();
  const location = useLocation();
  const currentURL = location.pathname;
  const { vendor } = useVendor();
  const SHOW_TERMS_CONTRACT = config.SHOW_TERMS_CONTRACT === 'true';
  const [showBroadband, setShowBroadband] = useState(false);

  useEffect(() => {
    if (!sessionOrderAccessToken && sessionResponse.length !== 0 && !loading && !expressLoading) {
      window.location.href = getBaseUrl();
      dispatch(resetState);
    }
  }, [])

  useEffect(() => {
    if (getBroadbandLabel?.data) {
    }  else if (isBroadbandLabelError) {
      setShowBroadband(false);
    }
  }, [getBroadbandLabel, isBroadbandLabelError]);

  useEffect(() => {
    return () => {
      dispatch({ type: CLEAR_BROADBAND_DATA });
    };
  }, [dispatch]);

  // Delete Mobile Plan
  const handleRemoveWireless = (index, plan) => {
    servRef = getUpdatedServRef(plan, servRef);
    dispatch(updateOrder({ serviceReference: servRef }, orderAccessToken));
    if (wirelessPlanInfo.length && !isInternetAdded) {
      wirelessPlanInfo.splice(index, 1);
      dispatch(setActiveProductTab('mobile'))
      navigate(routesConfig.products)
      EECproductRemoveFromCart(plan)
    }
    wirelessPlanInfo.splice(index, 1)
    dispatch(saveWirelessPlanInfo({
      wirelessPlanInfo: wirelessPlanInfo,
      wirelesServeRef: getWirelessServRef(wirelessPlanInfo)
    }));
    EECproductRemoveFromCart(plan);
    if (isBundleAdded) {
      const { servLevel1 = '', servLevel2 = '', servLevel3 = '', servLevel4 = '' } = selectedBundleData || {};
      if ([servLevel1, servLevel2, servLevel3, servLevel4]?.includes(plan?.servLevel) || [servLevel1, servLevel2, servLevel3, servLevel4]?.includes('*')) {
        dispatch(setSelectedBundle(null));
      }
      dispatch(saveVasPlanInfo({
        vasPlan: [],
        vasProductCart: []
      }));
    }
  };

  const internetProductsAndWirelessEdit = (value) => {
    dispatch(setActiveProductTab(value))
    navigate(routesConfig.products)
  }
  const handleRemoveVas = (index, plan) => {
    if (!window.location.href.includes('vasPage')) {
      servRef = getUpdatedServRef(plan, servRef);
      dispatch(updateOrder({ serviceReference: servRef }, orderAccessToken));
    }
    let mboxReq = mboxRequired;
    delete mboxReq[plan.servCode];
    dispatch(setMBoxReqObj(mboxReq));
    vasPlanInfo.vasPlan.splice(index, 1)
    vasPlanInfo?.vasProductCart?.splice(index, 1);
    dispatch(saveVasPlanInfo({
      vasPlan: vasPlanInfo.vasPlan,
      vasProductCart: vasPlanInfo.vasProductCart,
    }));
    EECproductRemoveFromCart(plan);

    if (isBundleAdded) {
      const { servLevel1 = '', servLevel2 = '', servLevel3 = '', servLevel4 = '' } = selectedBundleData || {};
      if ([servLevel1, servLevel2, servLevel3, servLevel4]?.includes(plan?.servLevel.toLowerCase())) {
        dispatch(setSelectedBundle(null));
      }
    }
  };

  const promoPrice = getPromoPrice(internetPlan, serviceTerm);
  const { isFFFlow, ffReferrerEmail, ffSiteToken, ffPromoCode } = useFFReferral();
  const regularPrice = (isFFFlow || !isWhiOrElfwPricing(internetPlan))
    ? getProductPrice(internetPlan, serviceTerm)
    : getValid$Cost(internetPlan?.price);

  const hasPromo = Boolean(promoPrice);
  const promoEndMonth = getPromoEndMonth(internetPlan, serviceTerm);
  const getInternetProducts = (value) => {
    return (
      <li>
        <div className="item-plan d-flex j-between">
          <div>
            {!isWhiAdded && 'Internet'} {internetPlan?.serviceName?.replace(/^earthlink /i, '')}
          </div>
          <div className="price-text">
            {hasPromo && !isSpc && (
              <span className="actual-price-text">{regularPrice}</span>
            )}

            <span className="discount-price-text">
              {hasPromo ? promoPrice : regularPrice}
              {value ? billingPeriod.monthly : ''}
            </span>
          </div>
        </div>
      </li>
    )
  };

  const getMobileProducts = (value) => {
    return (
      wirelessPlanInfo && wirelessPlanInfo.map((mobilePlan, i) => (
        <div className="item-plan d-flex j-between" key={i}>
          <div>
            ({mobilePlan.quantity}) Mobile {mobilePlan.serviceName.replace(' Plan', '')}
          </div>
          <div className="price-text">{getFixedCostWith$(mobilePlan.quantity * getMobilePrice(mobilePlan, 'cart'))}{value ? billingPeriod.monthly : ''}

            {!isProductsAdded && <span style={{ padding: '0px 0px 0px 6px' }} className={`delete-product ${loading ? 'disable-pointer' : ''}`} onClick={() => handleRemoveWireless(i, mobilePlan)} onKeyDown={()=>{}}>
              <i className="fa-solid fa-trash-can"></i>
            </span>
            }
          </div>
          <div className="dotted"></div>
        </div>
      ))
    )
  };
  const getVasProducts = (value) => {
    return (
      vasPlan && vasPlan.map((vasItem, i) => (
        <div className="item-plan d-flex j-between" key={i}>
          <div>
            <span className={`delete-product ${loading ? 'disable-pointer' : ''}`}
              onClick={() => handleRemoveVas(i, vasItem)} onKeyDown={()=>{}}>
            </span>
            {replaceServiceName(vasItem?.serviceName)}

          </div>
          <div className="price-text">{getValid$Cost(vasItem.price)}{value ? billingPeriod.monthly : ''}
            <span
              style={{ padding: '0 0 0 6px' }}
              className={`delete-product ${loading ? 'disable-pointer' : ''}`}
              onClick={() => {
                if (currentURL === routesConfig?.checkout || currentURL === routesConfig?.products) {
                  handleRemoveVas(i, vasItem)
                } else {
                  navigate(routesConfig.checkout)
                }
              }}
              onKeyUp={()=>{}}
            >
              {!isVasOnlyFlow && (
                currentURL === routesConfig?.checkout || currentURL === routesConfig?.products ?
                  <i className="fa-solid fa-trash-can"></i> :
                  <i className="fa-solid fa-edit"></i>
              )}
            </span>
          </div>
          <div className="dotted"></div>
        </div>
      ))
    )
  };

  // on Product page Checkout click
  const handleCheckout = () => {
    if (typeof props.handleContClick === 'function') {
      props.handleContClick();
    }
    dispatch(
      updateOrder(
        { orderStatus: OrderStatus.addedToCart, serviceReference: servRef, bbLabelServRef: servRef, promoCode: isBusinessAddress
          ? sessionResponse?.businessPromoCode
          : sessionResponse?.promoCode,
        partner: 'elnkwww', },
        orderAccessToken
      )
    );
    dispatch(saveFirstStep(!isProductsAdded));
  }
  const onCheckoutClick = () => {
    if (vendor?.toLowerCase() === 'verizon' && !scheduleAppt?.length) {
      dispatch(setRtsVisible(true));
    } else {
      handleCheckout();
      navigate(routesConfig.checkout);
    }
  }

  const toggleErrorModal = () => {
    setShowErrorModal(!showErrorModal);
  }

  const handleConfirmOrder = (autoAcceptTC = false) => {
    const bundleCode = isBundleAdded ? { ioPromoCode: bundleData?.find(el => el?.bundleCode === selectedBundleData?.bundleCode)?.bundleCode } : {};
    const promoCode = isBusinessAddress ? sessionResponse.businessPromoCode : sessionResponse.promoCode;
    const salesAgentId = sessionResponse.agentId;
    const customerAcceptedTC = autoAcceptTC || tcAgree;
    const tcOrderAgreed = moment().format('lll');
    // The session partner has to win. /prequal, initialOrderCreate and CompatibilityCheck all
    // read sessionResponse.partnerId, so discarding it here made the quote, the order record
    // and the submission disagree on every residential order.
    //
    // The configured fallback applies to the Friends & Family flow only. A halo landing page
    // carries no partner, so that flow needs a default - but applying one everywhere would
    // change every partnerless order from "no affiliateId field" to a hardcoded id, which is
    // a submission-shape change on ~100% of direct traffic that this ticket never asked for.
    const affiliateId = isFFFlow
      ? (sessionResponse.partnerId || (isBusinessAddress ? config.BUSINESS_PARTNER : config.RESIDENTIAL_PARTNER))
      : sessionResponse.partnerId;
    const installWindow = config.SHOW_SCHEDULE_APPT === 'true' && !isUndefinedNullOrEmpty(scheduleDateTime) ? { installWindow: scheduleDateTime.replace(/.000/g, '') } : {};
    const PaswdCqas = config.SHOW_PSWD_CQAS === 'true' ? { answer, question, password } : {}
    const installPhoneValue = !isUndefinedNullOrEmpty(installPhone) ? { installPhone: installPhone } : {};

    if (!isUndefinedNullOrEmpty(orderAccessToken)) {
      const orderSubmissionModel = getOrderSubmissionModel({
        accountEmail,
        affiliateId,
        agentReadTC,
        billingAddress,
        paymentType,
        ...(paymentType === 'bankDraft'
          ? { abaNum, bankAccountNum, bankAccountType }
          : {
            creditCardCSV: encryptedCvc,
            creditCardExp: expirationDate,
            creditCardNum: (encryptedCcn + '||' + integrityCheck),
          }),
        customerAcceptedTC,
        email,
        firstName,
        lastName,
        orderId: orderAccessToken,
        phoneNum,
        promoCode,
        salesAgentId,
        serviceAddress,
        serviceReference: servRef,
        isExpressContainer: isVasOnlyFlow || isMobileContainer,
        ...installWindow,
        isElnkMailboxReq,
        ...PaswdCqas,
        ...installPhoneValue,
        bundleCode,
        spanishLanguagePref,
        // No FF override here: source becomes broadbandOptionalFields.serviceName, which the
        // order API reads as the client/user name, so stamping it FF_REFERRAL replaced a value
        // the API needs. Reporting is driven by the promo code instead (Maxwell/Ann,
        // ELNKWEB-2988), and FF orders send the same serviceName as any other elnkwww order.
        source: referrerSourceMap[referrer] || null,
        serviceTerm,
        // Attribution comes from redux, not storage: getOrderSubmissionModel is a pure
        // function with no store access, so the caller hands it the verified values.
        ffReferrerEmail,
        ffSiteToken,
        ffPromoCode,
        installType,
        isCsiEligible,
      });

      dispatch(updateCustTC(customerAcceptedTC));
      dispatch(submitOrder(orderSubmissionModel))
        .then((response) => {
          dispatch(updateOrder({
            confirmationNum: response.value.data.confirmationNo,
            accountNumber: response.value.data.customerNumber,
            installDate: response.value.data.reqInstallDate,
            tcOrderAgreed,
            orderStatus: OrderStatus.orderSubmit,
            xmlcErrorMsg: null
          }, orderAccessToken)).then(() => {
            const HLPlan = isInternetAdded ? [internetPlan] : []
            clearSessionOrderAccessToken();
            EECtransactionSuccess({
              id: response.value.data.confirmationNo,
              total,
              isADSL,
              products: [...HLPlan, ...wirelessPlanInfo, ...vasPlan],
              modemFee,
              isInternetAdded,
              isMobileAdded,
              installationCost,
              adslShippingCost: adslCost,
              simCharge
            })

            /**
             * For successful order, set confirmation number.
             */
            leads?.updateOrder?.('Update Order: Set Confirmation Number', {
              confirmationNumber: response?.value?.data?.confirmationNo,
            });
            navigate(routesConfig.thanks);
          }).catch((err) => {
            dispatch(updateErrorMsg(err));
            dispatch(resetState());
            dispatch(clearSessionOrderAccessToken());
          });
        })
        .catch((err) => {
          const errorPayload = isUndefinedNullOrEmpty(err.response) ? '' : isUndefinedNullOrEmpty(err.response.data) ? '' : err.response.data
          if (errorPayload?.msg || errorPayload?.type === 'actionDisplayAppError'
          ) {
            dispatch(updateOrder({
              xmlcErrorMsg: errorPayload.msg || errorPayload.error,
              orderStatus: OrderStatus.orderError
            }, orderAccessToken));
            let errMsg = isUndefinedNullOrEmpty(errorPayload.msg) ? isUndefinedNullOrEmpty(errorPayload.errorMessage) ?
              'There was an issue processing your order. Please call Affiliate Support.' : errorPayload.errorMessage : errorPayload.msg;
            dispatch(updateErrorMsg(errMsg));
          } else if (
            errorPayload.type &&
            errorPayload.type === 'actionUpdatePaymentInfo'
          ) {
            dispatch(updateOrder({
              xmlcErrorMsg: errorPayload.error,
              orderStatus: OrderStatus.orderError
            }, orderAccessToken)).then(() => {
            })
            dispatch(updateErrorMsg(errorPayload.type));
          } else if (
            errorPayload.type &&
            (errorPayload.type === 'actionDisplayErrorModal' ||
              errorPayload.type === 'actionDisplayPrepaidModal' ||
              errorPayload.type === 'actionDisplayFloorModal')
          ) {
            dispatch(updateCardErrorModal(cardErrorModalMessage[errorPayload.type]));
            dispatch(updateOrder({
              xmlcErrorMsg: errorPayload.error,
              orderStatus: OrderStatus.orderError
            }, orderAccessToken)).then(() => {
              toggleErrorModal();
            })
            dispatch(updateErrorMsg(errorPayload.type));
          } else {
            dispatch(updateErrorMsg('There was an issue processing your order. Please call Affiliate Support.'));
          }
        });
    }
  };

  // Auto-submit order once payment details are saved
  useEffect(() => {
    if ((currentURL === routesConfig.checkout || isVasOnlyFlow) && encryptedCcn && !loading && !autoSubmitRef.current) {
      if (!props.submitOrderRef && isVasOnlyFlow && tcAgree) {
        autoSubmitRef.current = true;
        handleConfirmOrder(true);
      }
    }
  }, [currentURL, encryptedCcn, loading, props.submitOrderRef, isVasOnlyFlow, tcAgree, handleConfirmOrder]);

  useEffect(() => {
    const ref = props.submitOrderRef;
    if (!ref) {return undefined;}

    ref.current = handleConfirmOrder;

    return () => {
      if (ref.current === handleConfirmOrder) {
        ref.current = null;
      }
    };
  }, [handleConfirmOrder, props.submitOrderRef]);

  const handleResetAddress = () => {
    navigate(routesConfig.home)
    dispatch(saveScheduleDateTime(''));
    dispatch(saveInternetPlan({}))
    dispatch(setSelectedBundle(null));
    dispatch(saveWirelessPlanInfo({
      wirelessPlanInfo: [],
      wirelesServeRef: ''
    }));
    dispatch(setActiveProductTab(''))
  }

  const oneTimeChargesSection = !isVasOnlyFlow && (
    <div className="common-cart-section">
      <div className="">
        <div className="checkout_review_heading">
          <h4>{t('cart.oneTimeCharges')}</h4>
        </div>
        <ul className="">
          {isInternetAdded && <li>
            <div className="item-plan d-flex j-between cart-details-line">
              <div>{getOneTimeChargesLabel()}</div>
              <div className="price-text"><span className="discount-price-text"> {getOneTimeChargesLabelValue()}</span></div>
            </div>
          </li>}
          {isMobileAdded &&
            <>
              {mobileMrcCombinedVal > 0 ? <>{wirelessPlanInfo?.map((mobilePlan) => (
                <li key={uuid()}>
                  <div className="item-plan d-flex j-between">
                    <div>{getMobilePriceLabel(mobilePlan)}</div>
                    <div className="price-text">{getValid$Cost(getMobilePriceValue(mobilePlan)?.toFixed(2))}</div>
                    <div className="dotted"></div>
                  </div>
                </li>
              ))}
              <li>
                <div className="item-plan d-flex j-between">
                  <div>{t('cart.simCardFee')}</div>
                  <div className="price-text">{getValid$Cost(simCharge?.toFixed(2))}</div>
                  <div className="dotted"></div>
                </div>
              </li>
              </>
                : ''}
            </>
          }
        </ul>
      </div>
    </div>
  );

  const monthlyChargesSection = (
    <div className="common-cart-section">
      <div className="checkout_review_heading">
        <h4>{t('cart.monthlyCharges')}</h4>
        {/* <p>{getValid$Cost(isBundleAdded ? (Number(monthlyCharge) - bundleDiscount).toFixed(2) : monthlyCharge)} / mo</p> */}
        {/* <span className="checkout_edit" onClick={() => props.setActiveKey('1')}>Edit</span> */}
        {isProductsAdded &&
        <span className={`checkout_edit delete-product ${loading ? 'disable-pointer' : ''}`} onClick={() => internetProductsAndWirelessEdit('internet')} onKeyDown={()=>{}}>
          Edit
        </span>
        }
      </div>
      <div className="cart-details-line">
        <ul>
          {getInternetProducts(false)}
          {isInternetAdded &&
          <>
            <li>
              <div className="item-plan d-flex j-between">
                <div>{(internetPlan?.servCode?.toLowerCase()==='whi' && internetPlan?.equipmentShortName) || t('cart.modemLease')}</div>
                <div className="price-text">
                  {getValid$Cost(modemFee)}
                </div>
                {/* <div className="dotted"></div> */}
              </div>
            </li>
          </>
          }
          {isMobileAdded && getMobileProducts()}
          {vasPlan && vasPlan.length > 0 && getVasProducts()}
          {isBundleAdded && (
            <div className="item-plan d-flex j-between">
              <div style={{ flexDirection: 'column' }} >
                <div className="font-green">
                  {t('cart.bundleDiscount')}
                </div>
                <span>({selectedBundleData?.bundleName})</span>
              </div>
              <div className="price-text">
              ${bundleDiscount?.toFixed(2)}
              </div>
              <div className="dotted"></div>
            </div>
          )}
        </ul>
      </div>
    </div>
  );

  const totalMonthlyChargesSection = (
    <div className="common-cart-section">
      <div className="checkout_review_heading">
        <h4>{t('cart.totalMonthlyCharges')}</h4>
        {isProductsAdded &&
        <div className={`${!isVasOnlyFlow ? 'today-monthly-r' : ''}`}>
          <div>
            <h4>{getValid$Cost(totalMonthlyCharge)}*</h4>
          </div>
        </div>
        }
      </div>
      {(internetPlan?.contractLength || isWhiAdded) && (<>
        <div className="cart-details-line">
          <div className="item-plan">{t('cart.termGuarantee', { months: SHOW_TERMS_CONTRACT ? (internetPlan?.contractLength || '12') : '12' })}
          </div>
        </div>
        <div className="price-text_term">
          {hasPromo && (
            <Trans
              i18nKey={'cart.promoPriceTerms'}
              values={
                {  promoPrice,
                  regularPrice ,
                  months : promoEndMonth}
              }
              components={[<b key="promo" /> , <b  key="regular" />]}
            />
          )}
        </div>
      </>
      )}
      {isWhiAdded && (
        <div className="terms-text">
          <p>{t('cart.whiNote')}</p>
        </div>
      )}
    </div>
  );

  return (
    <>
      <div className={`fixed-on-scroll ${prodPage ? 'fixed-on-scroll-with-tab' : ''} ${isVasOnlyFlow ? 'vas-container' : ''}`}>
        <div className={`${!isVasOnlyFlow && 'review-header-non-vas-only-flow'}`}>
          <div className="d-none">
            <CheckoutHeadText />
          </div>
        </div>
        {showBroadband ?
          <BroadbandInfo back={() => setShowBroadband(false)} />
          :
          <div className="responsive-none resutl-fix-scroll resposive-space">
            <div>
              <div className="rightsidebar-cart" style={{marginTop: currentURL === routesConfig?.checkout && '0'}}>
                {productCount !== 0 ?
                  (isSpc ? (
                    <>
                      {rawScheduleDateTime && isProductsAdded && !isScheduleSuppressed && (
                        <div className="common-cart-section">
                          <div className="checkout_review_heading">
                            <h4>{t('cart.appointmentDate')}</h4>
                          </div>
                          <div className="item-plan cart-details-line">
                            <div>{formatLocalDate(rawScheduleDateTime.split(' to ')[0], 'dddd MMMM D, YYYY', spanishLanguagePref)}</div>
                            {/* Same "8:00 am – 12:00 pm" form as the appointment section - the
                                stored ' to ' separator is English and rendered as-is in Spanish. */}
                            <div>{rawScheduleDateTime.split(' to ').slice(1).join(' – ')}</div>
                          </div>
                        </div>
                      )}
                      {(isProductsAdded || (isVasOnlyFlow && vasPlan?.length > 0)) && (
                        <div className="common-cart-section">
                          <div className="service-cart">
                            <ul>
                              {!isMobileContainer && (
                                <li>
                                  <div className="item-plan">
                                    <div className="checkout_review_heading">
                                      <h4>{t('cart.serviceAddress')}</h4>
                                    </div>
                                    <div className="d-flex details-on-cart">
                                      {normalizedAddress?.address1 ? (
                                        <>
                                          <div>{normalizedAddress.address1}</div>
                                          <div>
                                            {[
                                              normalizedAddress.address2,
                                              `${normalizedAddress.city || ''}, ${normalizedAddress.state || ''} ${(normalizedAddress.zipCode || '').substring(0, 5)}`.trim(),
                                            ].filter(Boolean).join(' ')}
                                          </div>
                                        </>
                                      ) : serviceAddress}
                                    </div>
                                  </div>
                                </li>
                              )}
                              {shippingAddress?.length !== 0 && shippingAddress !== serviceAddress && (
                                <li>
                                  <span>{t('cart.shippingAddress')}</span>
                                  <div className="item-plan">
                                    <div className="d-flex">{shippingAddress}</div>
                                  </div>
                                </li>
                              )}
                              {billingAddress?.length !== 0 && billingAddress !== serviceAddress && (
                                <li className="billing-address-item">
                                  <div className="item-plan">
                                    <div className="checkout_review_heading">
                                      <h4>{t('cart.billingAddress')}</h4>
                                    </div>
                                    <div className="d-flex details-on-cart">{billingAddress}</div>
                                  </div>
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      )}

                      <div className="b-top"></div>

                      {!isVasOnlyFlow && (
                        <div className="common-cart-section">
                          <div className="checkout_review_heading">
                            <h4>{t('cart.oneTimeChargesSpc')}</h4>
                          </div>
                          <ul>
                            {isInternetAdded && (
                              <li>
                                <div className="item-plan d-flex j-between cart-details-line">
                                  <div>{getOneTimeChargesLabel()}</div>
                                  <div className="price-text"><span className="discount-price-text">{getOneTimeChargesLabelValue()}</span></div>
                                </div>
                              </li>
                            )}
                            {isMobileAdded && mobileMrcCombinedVal > 0 && (
                              <>
                                {wirelessPlanInfo?.map((mobilePlan) => (
                                  <li key={uuid()}>
                                    <div className="item-plan d-flex j-between">
                                      <div>{getMobilePriceLabel(mobilePlan)}</div>
                                      <div className="price-text">{getValid$Cost(getMobilePriceValue(mobilePlan)?.toFixed(2))}</div>
                                    </div>
                                  </li>
                                ))}
                                <li>
                                  <div className="item-plan d-flex j-between">
                                    <div>{t('cart.simCardFee')}</div>
                                    <div className="price-text">{getValid$Cost(simCharge?.toFixed(2))}</div>
                                  </div>
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                      )}

                      <div className="b-top"></div>

                      <div className="common-cart-section">
                        <div className="checkout_review_heading">
                          <h4>{t('cart.monthlyCharges')}*</h4>
                        </div>
                        <div className="cart-details-line">
                          <ul>
                            {getInternetProducts(false)}
                            {isInternetAdded && (
                              <li>
                                <div className="item-plan d-flex j-between">
                                  <div>{(isWhiAdded && internetPlan?.equipmentShortName) || t('cart.modemLease')}</div>
                                  <div className="price-text">{getValid$Cost(modemFee)}</div>
                                </div>
                              </li>
                            )}
                            {isMobileAdded && getMobileProducts()}
                            {vasPlan && vasPlan.length > 0 && getVasProducts()}
                            {isBundleAdded && (
                              <li>
                                <div className="item-plan d-flex j-between">
                                  <div style={{ flexDirection: 'column' }}>
                                    <div className="font-green">{t('cart.bundleDiscount')}</div>
                                    <span>({selectedBundleData?.bundleName})</span>
                                  </div>
                                  <div className="price-text">${bundleDiscount?.toFixed(2)}</div>
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>

                      {(internetPlan?.contractLength || isWhiAdded || hasPromo) && (
                        <>
                          <div className="b-top"></div>
                          <div className="common-cart-section spc-cart-terms">
                            <div className="checkout_review_heading">
                              <h4>{t('cart.terms')}</h4>
                            </div>
                            {(internetPlan?.contractLength || isWhiAdded) && (
                              <div className="cart-details-line">
                                <div className="item-plan">
                                  {t('cart.termGuarantee', { months: SHOW_TERMS_CONTRACT ? (internetPlan?.contractLength || '12') : '12' })}
                                </div>
                              </div>
                            )}
                            {hasPromo && (
                              <div className="price-text_term">
                                <Trans
                                  i18nKey={'cart.promoPriceTerms'}
                                  values={{ promoPrice, regularPrice, months: promoEndMonth }}
                                  components={[<b key="promo" />, <b key="regular" />]}
                                />
                              </div>
                            )}
                            {isWhiAdded && (
                              <div className="terms-text">
                                <p>{t('cart.whiNote')}</p>
                              </div>
                            )}
                          </div>
                        </>
                      )}

                      <div className="b-top"></div>

                      <div className="common-cart-section">
                        <div className="checkout_review_heading">
                          <h4>{t('cart.totalMonthlyCharges')}</h4>
                          {isProductsAdded && (
                            <h4>{getValid$Cost(totalMonthlyCharge)}</h4>
                          )}
                        </div>
                      </div>

                      <div className="common-cart-section total-row">
                        <div className="checkout_review_heading">
                          <div className="text-left left-total">
                            <h4>{t('cart.whatYouPayToday')}</h4>
                          </div>
                          {!isVasOnlyFlow && (
                            <div className="today-monthly-l">
                              <h4>{getOneTimeChargesHeadingValue()}</h4>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {rawScheduleDateTime && isProductsAdded && !isScheduleSuppressed &&(
                        <div className="review_order_wrapp">
                          <div className="common-cart-section first-top">
                            <div className="checkout_review_heading">
                              <h4>{t('cart.appointmentDate')}</h4>
                              {props.setActiveKey && (
                                <span className="checkout_edit" onClick={() => props.setActiveKey('1')}>
                                  Edit
                                </span>
                              )}
                            </div>
                            <div className="item-plan cart-details-line">
                              <div>
                                {moment(rawScheduleDateTime.split(' to ')[0]).format('dddd MMMM D, YYYY')}
                              </div>
                              <div>
                                {rawScheduleDateTime.split(' to ').slice(1).join(' to ')}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {(isProductsAdded || (isVasOnlyFlow && vasPlan?.length > 0)) &&
                      <div className="review_order_wrapp">
                        <div className="common-cart-section">
                          <div className="service-cart">
                            <ul>
                              {!isMobileContainer &&
                                <li>
                                  <div className="item-plan">
                                    <div className="checkout_review_heading">
                                      <h4>{t('cart.serviceAddress')}</h4>
                                      <span className="checkout_edit" onClick={() => {
                                        handleResetAddress()
                                      }}>
                                      Edit
                                      </span>
                                    </div>
                                    <div className="d-flex details-on-cart">{serviceAddress}</div>
                                  </div>
                                </li>
                              }
                              {shippingAddress?.length !== 0 && shippingAddress !== serviceAddress &&
                                <li>
                                  <span>{t('cart.shippingAddress')}</span>
                                  <div className="item-plan">
                                    <div className="d-flex">{shippingAddress}</div>
                                  </div>
                                </li>
                              }
                              {billingAddress?.length !== 0 && billingAddress !== serviceAddress &&
                                <li className="billing-address-item">
                                  <div className="item-plan">
                                    <div className="checkout_review_heading">
                                      <h4>{t('cart.billingAddress')}</h4>
                                      {props.setActiveKey && (
                                        <span className="checkout_edit" onClick={() => props.setActiveKey(paymentPanelKey)}>
                                          Edit
                                        </span>
                                      )}
                                    </div>
                                    <div className="d-flex details-on-cart">{billingAddress}</div>
                                  </div>
                                </li>
                              }
                            </ul>
                          </div>
                        </div>
                      </div>
                      }
                      <div className="review_order_wrapp p_review_order_wrapp">
                        <div className="b-top"></div>
                        {oneTimeChargesSection}
                        {!isVasOnlyFlow && <div className="b-top"></div>}
                        {monthlyChargesSection}
                        {totalMonthlyChargesSection}
                        {/* <div className="b-top"></div> */}
                        <div className="common-cart-section total-row ">
                          <div>
                            <div className="checkout_review_heading">
                              <div className="text-left left-total">
                                <div>
                                  <h4>{t('cart.whatYouPayToday')}</h4>
                                </div>
                              </div>
                              <div className="d-flex j-end right-total">
                                {!isVasOnlyFlow && (
                                  <div className="today-monthly-l">
                                    <h4>{getOneTimeChargesHeadingValue()}</h4>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="review-button">
                        {!isProductsAdded && (
                          <button className="blue-button" disabled={!isMobileAdded && !isInternetAdded} onClick={() => {
                            onCheckoutClick()
                          }}>{t('common.checkout')}</button>
                        )}
                      </div>
                    </>
                  )) :
                  <>
                    <div className="b-top result-none"></div>
                    <div className="cart-empty">
                      {t('cart.cartEmpty')}
                    </div>
                  </>
                }
              </div>
            </div>
            {!isVasOnlyFlow && <div>
              <div>
                {isMobileAdded && <MobileInfomration />}
              </div>
              {!isSpc && <p className="terms-conditions">{isScheduleSuppressed ? t('cart.taxesNoteActivated') : t('cart.taxesNoteInstalled')}</p>}
            </div>}
          </div>
        }
      </div>
      {!isSpc && <RtsModal handleCheckout={handleCheckout} />}
    </>
  )
}


CartInformation.propTypes = {
  handleContClick: PropTypes.func.isRequired,
  isSpc: PropTypes.bool,
};

export default CartInformation;
